import { cn as p } from "../../../lib/shadcn/utils/utils.js";
import h from "../../../assets/svg/Checkmark/Checkmark.js";
import { useAppRouter as b } from "../../providers/AppRouterProvider/AppRouterProvider.js";
import x from "../../../assets/svg/ArrowDown/ArrowDown.js";
import { useClickOutside as y } from "../../../hooks/useClickOutside/useClickOutside.js";
import { AVAILABLE_LANGUAGE_NAMES as k, setDefaultLanguage as v } from "../../../helpers/defaultLanguage.helper.js";
import { useRef as C, useState as w } from "react";
import { jsx as t, jsxs as i } from "react/jsx-runtime";
import { IDS as o } from "e2e-page-objects/selectors";
import { useTranslation as N } from "react-i18next";
var A = Object.keys(k), q = ({ className: m }) => {
  const { i18n: u } = N(), { getCurrent: l, replaceTo: g } = b(), [c, s] = w(!1), d = C(null);
  y({
    ref: d,
    onClickOutside: () => s(!1),
    enabled: c
  });
  const n = u.language, f = (e) => {
    s(!1);
    const r = l(), a = { ...r.query };
    a.redir && (a.redir = String(a.redir).replace(`/${r.params?.locale}/`, `/${e}/`)), g({
      name: r.name ?? void 0,
      params: {
        ...r.params,
        locale: e
      },
      query: a,
      hash: r.hash
    })?.catch(() => {
    }), v(e);
  };
  return /* @__PURE__ */ i("div", {
    ref: d,
    className: p("relative flex items-center justify-between uppercase", m),
    "data-testid": "language-chooser",
    children: [/* @__PURE__ */ i("button", {
      type: "button",
      name: o.languageChooserToggle,
      "data-dd-action-name": o.languageChooserToggle,
      className: "flex h-8.75 cursor-pointer appearance-none items-center border-0 bg-transparent p-0",
      onClick: () => s((e) => !e),
      children: [/* @__PURE__ */ t("span", {
        className: "mr-2 text-body-2 text-secondary-900 uppercase",
        children: n
      }), /* @__PURE__ */ t(x, {
        className: "size-3 **:stroke-secondary-900 **:stroke-[1.5]",
        "data-testid": "arrow-down"
      })]
    }), c && /* @__PURE__ */ t("div", {
      className: "absolute top-full left-0 z-20 max-h-100 w-15.5 overflow-y-auto bg-white shadow-[0px_0px_6px_0px_#e6e9ec]",
      children: A.map((e) => /* @__PURE__ */ i("button", {
        type: "button",
        name: o.languageChooserOption(e),
        "data-dd-action-name": o.languageChooserOption(e),
        className: p("relative box-border flex h-10.25 w-full cursor-pointer items-center justify-between border-t border-b border-solid border-transparent px-2.5 leading-10 hover:border-secondary-200", { "bg-secondary-050": e === n }),
        onClick: () => f(e),
        children: [/* @__PURE__ */ t("span", {
          className: "mr-2 text-body-2 text-secondary-900 uppercase",
          children: e
        }), e === n && /* @__PURE__ */ t(h, {
          className: "size-3 **:stroke-secondary-900 **:stroke-[1.5]",
          "data-testid": "check"
        })]
      }, e))
    })]
  });
};
export {
  q as LanguageChooser
};

//# sourceMappingURL=LanguageChooser.js.map